const s=function(s){if(!s)return{minutes:"00",seconds:"00"};const n=new Date(1e3*s).toISOString().substring(11,19);return{hours:`${parseInt(n.substring(0,2),10)}`,minutes:n.substring(3,5),seconds:n.substring(6,8)}};export{s as formatTime};
